// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IrWGD","rootMobile":"styles_rootMobile__2CTEJ"};